import React from 'react';
import { Button } from "@mantine/core";

const Modal = ({ imageUrl, closeModal }) => {
  const handleClickOutside = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleClickOutside}
    >
      <img
        src={imageUrl}
        alt="Modal"
        className="max-w-full max-h-screen object-contain"
        onClick={closeModal}
      />
      <Button
        variant="subtle"
        size="sm"
        className="absolute top-0 right-0 m-4"
        style={{ color: 'white' }}
        onClick={closeModal}
      >

      </Button>
    </div>
  );
};

export default Modal;
